import { createContext, useContext } from 'react';

export const emptyDashboardData = {
  registrationInProgress: [],
  enrolled: [],
  completed: [],
  adi12EnrollmentLetters: [],
  activeTab: 'REGISTER',
};

export const DashboardContext = createContext(null);

export function useDashboardData() {
  return useContext(DashboardContext);
}
